import { AI_GENERATED } from "@fronterahealth/frontera-ui-components";

import { useGoalBankGoalsQuery } from "@api/graphql/types-and-hooks";

export const useGetShortTermGoals = (selectedFolderId: string, searchTerm?: string) => {
  const {
    data: shortTermGoals,
    refetch: refetchStg,
    isLoading: stgIsLoading,
  } = useGoalBankGoalsQuery(
    { folderId: selectedFolderId, searchTerm },
    {
      queryKey: ["short-term-goals-" + selectedFolderId + "search-term-" + searchTerm],
      refetchOnMount: "always",
      refetchOnWindowFocus: false,
      refetchInterval: 200000,
      enabled: !!selectedFolderId && selectedFolderId !== AI_GENERATED,
    },
  );

  return {
    shortTermGoals,
    refetchStg,
    stgIsLoading,
  };
};
